import { useSelector } from "react-redux";
import Decimal from "decimal.js";
import { getGroupAvailability, getProductAvailability } from "./useWorkingTime";
import { buildUpsell } from "../utils/upsell";
import { selectStatefulCosts } from "../ducks/checkoutSlice";

/**
 * As sugestões do "Peça também" da sacola, as mesmas no celular (CartUpsell)
 * e no totem (Selfcheckout/CartUpsellTotem): o que pode ser oferecido agora
 * (disponível e fora da sacola) passa pelas regras de utils/upsell.js.
 *
 * `canQuickAdd` decide a ordem (o que o "+" adiciona direto vem antes); no
 * totem ele é sempre falso e o card abre o produto.
 *
 * Abaixo do pedido mínimo da entrega, `missing` diz quanto falta.
 */
export default function useCartUpsell({ canQuickAdd }) {
  const { items: products, groups } = useSelector((state) => state.products);
  const toDelivery = useSelector((state) => state.checkout.toDelivery);
  const deliveryMinimalCost = useSelector(
    (state) => state.shop.deliveryMinimalCost,
  );
  const { subtotal } = useSelector(selectStatefulCosts);
  const productOrders = useSelector(
    (state) => state.shoppingCart.productOrders,
  );
  const inCart = productOrders
    .filter((o) => o.commited)
    .map((o) => o.productId);

  const availableGroupIds = groups
    .filter((g) => getGroupAvailability(g).isAvailable)
    .map((g) => g.id);
  const candidates = products.filter(
    (p) =>
      !p.disabled &&
      !inCart.includes(p.id) &&
      (!toDelivery || p.deliveryVisible) &&
      availableGroupIds.includes(p.groupId) &&
      getProductAvailability(p).isAvailable,
  );

  const missing =
    toDelivery && deliveryMinimalCost > 0
      ? Decimal(deliveryMinimalCost).minus(subtotal || 0)
      : Decimal(0);
  const belowMinimum = missing.greaterThan(0);

  const { title, items: suggestions } = buildUpsell({
    candidates,
    cartProducts: products.filter((p) => inCart.includes(p.id)),
    groups,
    canQuickAdd,
    belowMinimum,
  });

  return { title, suggestions, belowMinimum, missing };
}
